module.exports = __webpack_public_path__ + "media/dashboard/assets/images/profile_lock-68b1cc8819a1b441e0674ca048a91029.svg";